window.context = '';

	window.CKEDITOR_BASEPATH = '/ckeditor/';

	window.customer='orpea';